import { useState } from 'react';
import clsx from 'clsx';
import { initials } from '../../lib/formatters';
import './account.css';

export interface AvatarProps {
  displayName: string | null;
  pictureUrl: string | null;
  /** Pixel size of the avatar (default 56). */
  size?: number;
  /** Gradient-ring treatment with a white inner disc (overview/profile). */
  ring?: boolean;
}

/** Avatar with a graceful initials fallback — never crashes on missing picture (spec §7.5). */
export function Avatar({ displayName, pictureUrl, size = 56, ring = false }: AvatarProps) {
  const [broken, setBroken] = useState(false);
  const showImage = pictureUrl && !broken;
  const content = showImage ? (
    <img src={pictureUrl} alt="" onError={() => setBroken(true)} />
  ) : (
    initials(displayName)
  );
  return (
    <span
      className={clsx('avatar', ring && 'avatar--ring')}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {ring ? <span className="avatar__inner">{content}</span> : content}
    </span>
  );
}
